import React, { useState, useEffect, useRef, memo } from "react";
import _ from "lodash";
import Transform from "pages/Pins/utils/transform.js";
import { SiteSetupAction } from "globalStore/globalStore";
import { useHookstate } from "@hookstate/core";
import cogIcon from "assets/images/cog.png";
import { settingsPoITypes } from "constant";

const LoadPreviewImage = ({ siteSetupData, mapInformationData }) =>{

const {
    imageHoleNo,
    courseNo,
    typeHole,
    isPreviewImageZoomed,
    } = useHookstate(SiteSetupAction);

const canvasRef = useRef(null);

const [siteSetupLocalState, setSiteSetupLocalState] = useState([]);
const [PoIs, setPoIs] = useState([]);
const [teeMarkers, setTeeMarkers] = useState([]);
const [centerGreens, setCenterGreens] = useState([]);
const [settingsTees, setsettingsTees] = useState([]);
const [selectedSiteData, setSelectedSiteData] = useState([]);
const [holeType, setHoleType] = useState(0);

useEffect(() => {
    if(typeHole.get() === settingsPoITypes.hole)
        setHoleType(settingsPoITypes.approach)
    else 
        setHoleType(settingsPoITypes.hole)
  },[typeHole.get(),]);

useEffect(() => {
    if(siteSetupData)setSiteSetupLocalState(siteSetupData)
    if(mapInformationData)setSelectedSiteData(mapInformationData)
  }, [siteSetupData, mapInformationData,]);

useEffect(() => {
    setPoIs(siteSetupLocalState?.PointsOfInterest)
    setTeeMarkers(siteSetupLocalState?.TeeMarkers)
    setCenterGreens(siteSetupLocalState?.HoleDatas)
    setsettingsTees(siteSetupLocalState?.TeeMarkerSettings)
}, [siteSetupLocalState]);

let labelWidth = 67;
let labelHeight = 41;
let triangleHeight = 15;

const canvas = canvasRef.current;
const imageObj = new Image();
const context = canvas?.getContext('2d');  

if(selectedSiteData && context){  
    context.setTransform(1, 0, 0, 1, 0, 0);
    //context.clearRect(0, 0, context.canvas.width, context.canvas.height);
    if (isPreviewImageZoomed.get()) {
        context.canvas.height = 300;
        context.canvas.width = 512;
        context.setTransform(0.5, 0, 0, 0.5, 0, 0);
    } else {
        context.canvas.height = 150;
        context.canvas.width = 262;
        context.setTransform(0.25, 0, 0, 0.25, 0, 0);
    }

    imageObj.onload = function () {
        // Draw the map
        context.drawImage(imageObj, 0, 0);

        // Create a transform to translate the lat/long values to X, Y coordinates
        let worldToImage = new Transform();
        worldToImage.m = [
            selectedSiteData.XScale, 
            selectedSiteData.YRotate, 
            selectedSiteData.XRotate, 
            selectedSiteData.YScale, 
            selectedSiteData.XOffset, 
            selectedSiteData.YOffset
        ];
        context.fillStyle = 'white';
        const drawCircle = (x, y) => {
            context.beginPath();
            let radius = isPreviewImageZoomed.get() ? 6 : 10; // Arc radius
            let startAngle = 0; // Starting point on circle
            let endAngle = Math.PI + (Math.PI); // End point on circle
            let anticlockwise = i % 2 === 0 ? false : true; // clockwise or anticlockwise

            context.arc(x, y, radius, startAngle, endAngle, anticlockwise);
            context.fillStyle = '#ffffff';
            context.fill();
        };

        const drawSquare = (x, y, color, size) => {
            context.fillStyle = color;
            context.fillRect(x - size / 2, y - size / 2, size, size);
        };
        const drawPoI = (data) => {
            // Get the X, Y values
            let loc = worldToImage.transformPoint(data.Lon, data.Lat);
            // Draw the point
            drawSquare(loc[0], loc[1], 'black', isPreviewImageZoomed.get() ? 14 : 22);
            drawCircle(loc[0], loc[1]);

            // Determine offset for the label
            switch (data.LabelPosition) {
                case 0: //left
                    loc[0] -= labelWidth + triangleHeight;
                    loc[1] -= 20;
                    break;
                case 1: //right
                    loc[0] += triangleHeight;
                    loc[1] -= labelHeight / 2 + 2;
                    break;
                case 2: //above
                    loc[0] -= labelWidth / 2 + 1;
                    loc[1] -= labelHeight + triangleHeight;
                    break;
                case 3: //below
                    loc[0] -= labelWidth / 2 + 1;
                    loc[1] += triangleHeight + 2;
                    break;
            }

            // Draw a label with sample text.
            context.fillStyle = 'white';
            context.fillRect(loc[0], loc[1], labelWidth, labelHeight);
            context.strokeStyle = 'black';
            context.lineWidth = 2;
            context.strokeRect(loc[0] - 1, loc[1] - 1, labelWidth + 2, labelHeight + 2);
            context.fillStyle = "black";
            context.font = "bold 36px Arial";
            context.fillText("999", loc[0] + 4, loc[1] + labelHeight - 5);
            };

        const drawCog = (data) => {
            // Get the X, Y values
            let loc = worldToImage.transformPoint(data.CogLon, data.CogLat);

            // Draw the Cog image
            let cog = new Image();
            cog.onload = function () {
                // Draw the map
                context.drawImage(cog, loc[0] - cog.width / 2, loc[1] - cog.width / 2);
            };

            cog.src = selectedSiteData.type === 2 ? cogIcon:cogIcon;
        };

        const drawTee = (data) => {
            // Get the X, Y values
            let loc = worldToImage.transformPoint(data.Lon, data.Lat);
            
            // Find the tee color
            let color = '#ffffff';
            let teeSetting = _.filter(settingsTees, { Id: data.TeeMarkerSettingId });
            if (teeSetting.length === 1) color = teeSetting[0].Name;

            drawSquare(loc[0], loc[1], 'white', isPreviewImageZoomed.get() ? 12 : 20);
            drawSquare(loc[0], loc[1], color, isPreviewImageZoomed.get() ? 8 : 16);
        };

        // Draw markers at the POI
        let itemsToDraw = _.filter(PoIs, { Course: courseNo.get(), Hole: imageHoleNo.get(), Type:holeType });
        _.forEach(itemsToDraw, drawPoI);
        
        let cogsToDraw = _.filter(centerGreens, { Course: courseNo.get(), Hole: imageHoleNo.get() });
        _.forEach(cogsToDraw, drawCog);

        let teesToDraw = _.filter(teeMarkers, { Course: courseNo.get(), Hole: imageHoleNo.get() });
        _.forEach(teesToDraw, drawTee);
    }

    if(selectedSiteData?.Data) {
        let byteCharacters = atob(selectedSiteData?.Data);
        let byteNumbers = new Array(byteCharacters.length);
        for (var i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        let byteArray = new Uint8Array(byteNumbers);

        let blob = new Blob([byteArray], { type: 'image/jpeg' });
        let url = URL.createObjectURL(blob);
        imageObj.src = url;
    }
  }

  return (
    <>
      <canvas
        ref={canvasRef}
        style={{ border: '1px solid black' }}
      >
      </canvas>
    </>
    )
}

export default memo(LoadPreviewImage)